import { Component, OnInit, Input, Output, ViewChild, EventEmitter, AfterViewInit, OnChanges, SimpleChanges, ElementRef } from '@angular/core';

@Component({
  selector: 'app-grid-checkbox-filter',
  templateUrl: './grid-checkbox-filter.component.html',
  styles: []
})
export class GridCheckboxFilterComponent implements AfterViewInit, OnChanges {
  @Input() actualFilterState: string;
  @Input() isReadonly: boolean = false;
  @Output() stateChanged = new EventEmitter<string>();
  @ViewChild('filterCheckbox') checkbox: ElementRef;
  private actualInnerState = '';

  constructor() { }

  ngAfterViewInit() {
    if(this.actualFilterState) {
      this.actualInnerState = this.actualFilterState;
      switch (this.actualFilterState) {
        case 'true':
          this.setChecked(this.checkbox.nativeElement);
          break;

        case 'false':
          this.setUnChecked(this.checkbox.nativeElement);
          break;
      
        default:
          this.setIndeterminate(this.checkbox.nativeElement);
          break;
      }
    } else {
      this.setIndeterminate(this.checkbox.nativeElement);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['actualFilterState']) {
      const currentValue = changes['actualFilterState'].currentValue;
      if (currentValue === '' && currentValue !== this.actualInnerState) {
        this.setIndeterminate(this.checkbox.nativeElement);
      }
    }
  }

  changeState(event) {
    if(this.isReadonly === true) {
      return;
    }

    const el = event.target;
    if (el.readOnly) {
      this.setUnChecked(el);
      this.stateChanged.emit('false');
    } else {
      if (!el.checked) {
        this.setIndeterminate(el);
        this.stateChanged.emit('');
      } else {
        this.stateChanged.emit('true');
      }
    }
  }

  private setIndeterminate(el: any) {
    this.actualInnerState = '';
    el.readOnly = el.indeterminate = true;
  }

  private setChecked(el: any) {
    this.actualInnerState = 'true';
    el.indeterminate = el.readOnly = false;
    el.checked = true;
  }

  private setUnChecked(el: any) {
    this.actualInnerState = 'false';
    el.checked = el.readOnly = false;
  }
}